<template>
    <div class="main">
        <div class="mainContent">
            <h2 class="card-title">Early Embryo Screen</h2>
            <p>
                In the Sönnichsen screen, 19,075 genes were screened for RNAi knockdown phenotypes by examining the progeny of injected worms The 1668 genes whose knockdown exhibited an embryonic, larval or adult phenotype, were rescreened by filming the first two divisions of at least five embryos by time-lapse DIC microscopy. 40,000 DIC recordings were acquired and manually inspected for a set of 45 specific defects. 661 genes with detectable early embryonic phenotypes were identified. Genes whose knockdown gave similar defect patterns were manually grouped in 23 phenotypic distinct classes. For the defect map, one representative experiment, in which approximately five embryos were filmed, was chosen and each of the 45 defect categories was assigned a single digit score based on phenotypic penetrance. These scores are represented here as distinct colors.
                <br/>
                <br/>
                In the subsequent Green et al. 2011 screen, these phenotypic profiles were compared using the Connection Specificity Index (CSI) as a similarity metric. For the early embryonic data, PhenoBank displays the top phenotypic matches for a query gene based on this metric.
            </p>

            <h4 class="round">Reference and Link to paper</h4>

            • PMID: <a href="https://pubmed.ncbi.nlm.nih.gov/15791247/" target="_blank">15791247</a>, DOI: <a href="https://doi.org/10.1038/nature03353" target="_blank">10.1038/nature03353</a>

          <h4 class="round">Movie</h4>
            <div class="row">
              <div class="col-sm-12">
              <video controls loop autoplay height="200" src="/mov/Wild-Type_early_emb.mp4">
                Sorry, your browser doesn't support embedded videos.
              </video>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ProjectDescription.vue",
    metaInfo: {
      title: 'Early Embryo Screen',
      // override the parent template and just use the above title only
      // titleTemplate: null,
      meta: [
        { vmid: 'description', name: 'description', content: 'In the Sönnichsen screen, 19,075 genes were screened for RNAi knockdown phenotypes by examining the progeny of injected worms The 1668 genes whose knockdown exhibited an embryonic, larval or adult phenotype, were rescreened by filming the first two divisions of at least five embryos by time-lapse DIC microscopy. 40,000 DIC recordings were acquired and manually inspected for a set of 45 specific defects. 661 genes with detectable early embryonic phenotypes were identified. Genes whose knockdown gave similar defect patterns were manually grouped in 23 phenotypic distinct classes. For the defect map, one representative experiment, in which approximately five embryos were filmed, was chosen and each of the 45 defect categories was assigned a single digit score based on phenotypic penetrance. These scores are represented here as distinct colors.' },
      ]
    },
  }
</script>

<style scoped>
    @import url('~@/assets/bootstrap.css');
    @import url('~@/assets/datatable.css');
    @import url('~@/assets/tooltip.css');

    .main {
        margin: 1.5rem;
    }

    h3 {
      margin: 40px 0 0;
    }
    .round {
      font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial;
      border-radius: 7px;
      border: 1px solid #d9d9d9;
      background: #dae3f3;
      padding: 3px 7px 3px 7px;
      font-style: oblique;
      color: #203864;
      font-weight: bold;
    }

    p.strong {
      text-decoration: underline;
      font-style: oblique;
    }

    h2.card-title {
      margin-top: 0;
      color: #2f5597;
      font-style: oblique;
    }

    h5.card-title {
      color: #2f5597;
      font-style: oblique;
      font-weight: bold;
    }

    .mainContent {
      border-radius: 25px;
      border: 2px solid #dae3f3;
      padding: 20px;
    }

    a {
      color: #0066ff;
    }

    p.summary {
      color: #114188;
      line-height: 1.2;
      font-weight: normal;
      font-style: oblique;
      font-size: 15px;
    }

    .modal-title {
      color: #114188;
      font-weight: bold;
      font-size: 18px;
    }

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-viewer {
      width: 830px;
    }
</style>
